import { render, staticRenderFns } from "./NewUserComponent.vue?vue&type=template&id=235f3adc&scoped=true"
import script from "./NewUserComponent.vue?vue&type=script&lang=js"
export * from "./NewUserComponent.vue?vue&type=script&lang=js"
import style0 from "./NewUserComponent.vue?vue&type=style&index=0&id=235f3adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f3adc",
  null
  
)

export default component.exports